import { LinearProgress } from '@mui/material';
import React from 'react';

import { useIsWidthUp } from '../utils';

const FixedLinearProgress = ({ visibility, alwaysShow }) => {
    const isSmallScreen = !useIsWidthUp('sm');
    if (!visibility && !alwaysShow) {
        return null;
    }
    return <LinearProgress color="primary" style={{ position: 'fixed', zIndex: 1, top: isSmallScreen ? '3.9rem' : 0, left: 0, right: 0 }} />;
};

export default FixedLinearProgress;
